import React from "react";

function TextFieldPerncentage(props) {
  const [value, setValue] = React.useState(null);
  const [ischecked, setchecked] = React.useState(null);
  const [ischecked1, setchecked1] = React.useState(null);
  React.useEffect(() => {
    if (props.value) {
      setValue(props.value.replace(/['"]+/g, ""));
    }
    
     
      //let val = props.wholeEl.ischecked.slice(1, props.wholeEl.ischecked.length - 1);
      
      setchecked(props.wholeEl.ischecked === true ? "checked" : false);
      setchecked1(props.wholeEl.ischecked);
  }, []);



  
  const onChange = (e) => {
    const value = e.target.value;

    // Only allow numbers
    if (!isNaN(value)) {
    setValue(e.target.value);
   
      props.setData({...props.wholeEl,value : e.target.value,ischecked:ischecked1})

    }
  };

  const onChange1 = (e) => {
    setchecked(e.target.checked);
    setchecked1(e.target.checked);
    props.setData({...props.wholeEl,...props.wholeEl.ischecked,ischecked : e.target.checked,value : value})
   

  };
  async function showInfo(e){}
  
  if(props.IsManual=="1"){
    return (
      <div class="col-md-4">
        <label >{props.name}
        </label>
         <div>
        <input
          type="text"
         key={props.structureType + props.id}
         id={props.structureType + props.id}
          value={value}
         onChange={onChange}
          //placeholder={props.name}
        
          class="form-control"
          
        /></div>
        <label class="checkbox-container check" for={"c"+props.structureType + props.id} > 
        <input type="radio" style={{width:"0px"}}  key={"c"+props.structureType + props.id} 
         id={"c"+props.structureType + props.id} onChange={onChange1} checked={ischecked} name={props.structureType+"LandAnalysis"} />
         
       </label>
      </div>
    );
  }
  else
  {
    return (
      <div class="col-md-4">
        <label >{props.name}
        </label>
        <div>
        <input
          type="text"
         key={props.structureType + props.id}
         id={props.structureType + props.id}
          value={value}
         onChange={onChange}
          //placeholder={props.name}
        
          class="form-control"
          
        /></div>
         <label class="checkbox-container">
        <input type="checkbox"  key={"c"+props.structureType + props.id}
         id={"c"+props.structureType + props.id} onChange={onChange1} checked={ischecked} />
          <span class="checkmark checkmark1"><i class="fa fa-pencil" style={{padding:"10px", marginTop:"3px"}}></i></span>
        </label>
       
      </div>
    );
  }
 
}

export default TextFieldPerncentage;
